<template>
  <div
    class="containerFull_marathon"
    id="containerFull_body"
    v-if="currThemeObj"
  >
    <div class="fix_header">
      <platfrom_menu
        :currThemeObj="currThemeObj"
        :selectData="platfromMenu_selectData"
        :userInfor="platfromMenu_userInfor"
        :groupList="platfromMenu_groupList"
        :currGroup="platfromMenu_currGroup"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        @changeSidToInitPageEvent="changeSidToInitPage"
        @changeSidEvent="platfrom_changeSid"
        @changeGroupEvent="platfromMenu_changeGroup"
      ></platfrom_menu>
    </div>
    <div class="mix_body">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currGroup="platfromMenu_currGroup"
        :groupChangeInitPage="containThemeRouteName"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        :themeHeaderBannerImage="'scheduleDetail_banner'"
      ></router-view>
    </div>

    <div class="mix_footer">
      <component :is="footerCustomDom" :currThemeObj="currThemeObj" />
    </div>
    <publicThemeDialog
      v-if="isShowPublicThemeDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isShowPublicThemeDialog"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="axiosBaseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      @publicThemeDialogEvent="publicThemeDialogHandler"
    ></publicThemeDialog>
  </div>
</template>

<script>
// 马拉松 【横琴马拉松】 公共容器
import marathonCommon_data_mixin from '@mixins/marathon/marathonCommon_data_mixin'

export default {
  name: 'marathon_common',
  props: {
    bigSportsList: {
      type: [Array, null],
      default: null,
    },
    containerFullClassName: {
      type: String,
      default: '',
    },
    defaultPath: {
      type: Array,
      default: () => {
        return []
      },
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
    themeSeasonArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mixins: [marathonCommon_data_mixin],
}
</script>

<style lang="scss">
.containerFull_marathon {
  position: relative;
  width: 100%;
  height: auto;
  font-size: 0.972vw;
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: 8vw;
    background-color: var(--mixtmt_whiteColor);
  }
  & .mix_body {
    min-height: calc(100vh - 8vw - 9.722vw);
  }
  & .mix_footer {
    /* position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1000; */
    width: 100%;
  }
}

.mixtmt_pc {
  .containerFull_marathon {
    padding: 8vw 9.722vw 9.722vw;
  }
}
.mixtmt_ipad {
  .containerFull_marathon {
    padding: 8vw 3vw 9.722vw;
  }
}
@media screen {
  /* #app.mixtmt_pc {
      .containerFull_marathon {
      }
    } */
}
</style>
